import utils from '@/utils'

const LIST_PARAMS_KEY = 'subscriptionPackage:listParams'

export const subscriptionPackage = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    listLoading: false,
    detail: {},
    detailLoading: false,
    deleteLoading: false,
    listParams: JSON.parse(localStorage.getItem(LIST_PARAMS_KEY)),
    searchList: {
      data: [],
      meta: {},
    },
    searchListLoading: false,
  },
  getters: {
    list: (state) => {
      return state.list
    },
    detail: (state) => {
      return state.detail
    },
    isListLoading: (state) => {
      return state.listLoading
    },
    isDetailLoading: (state) => {
      return state.detailLoading
    },
    isDeleteLoading: (state) => {
      return state.deleteLoading
    },
    listParams: (state) => {
      return state.listParams
    },
    searchList: (state) => {
      return state.searchList
    },
    isSearchListLoading: (state) => {
      return state.searchListLoading
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setDetail(state, data) {
      state.detail = data
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
    setDetailLoading(state, data) {
      state.detailLoading = data
    },
    setDeleteLoading(state, data) {
      state.deleteLoading = data
    },
    setListParams(state, data) {
      localStorage.setItem(LIST_PARAMS_KEY, JSON.stringify(data))
    },
    setSearchList(state, data) {
      state.searchList = data
    },
    setSearchListLoading(state, data) {
      state.searchListLoading = data
    },
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/subscription-packages`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'subscriptionPackage/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
    async search({ commit, dispatch }, { search, filters }) {
      commit('setSearchListLoading', true)
      try {
        const response = await axios.get(`/api/subscription-packages`, {
          params: {
            search,
            ...filters,
          },
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setSearchList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'subscriptionPackage/search', error },
          { root: true }
        )
      } finally {
        commit('setSearchListLoading', false)
      }
    },
    async getDetail({ commit }, id) {
      commit('setDetailLoading', true)
      const response = await axios.get(`/api/subscription-packages/${id}`)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async create({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.post('/api/subscription-packages', data)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async update({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.put(
        `/api/subscription-packages/${data.id}`,
        data
      )
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async delete({ commit }, id) {
      commit('setDeleteLoading', true)
      await axios.delete(`/api/subscription-packages/${id}`)
      commit('setDeleteLoading', false)
    },
  },
}
